import React, { useState, useEffect } from 'react';
import TitleBlock from '../elements/TitleBlock';
import { PiHandWithdrawBold, PiHandDepositBold } from "react-icons/pi";

function ProfileCard() {
  const [tokens, setTokens] = useState(null);
  const [balance, setBalance] = useState(null);
  const [withdrawError, setWithdrawError] = useState('');

  // Состояния для модальных окон
  const [depositModalOpen, setDepositModalOpen] = useState(false);
  const [withdrawModalOpen, setWithdrawModalOpen] = useState(false);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

  // Состояния для формы депозита
  const [depositToken, setDepositToken] = useState('');
  const [depositDropdownOpen, setDepositDropdownOpen] = useState(false);
  const [depositSearchQuery, setDepositSearchQuery] = useState('');
  const [depositField2, setDepositField2] = useState(''); // сумма
  const [depositField3, setDepositField3] = useState(''); // сеть
  const [depositField4, setDepositField4] = useState(''); // адрес

  // Состояния для формы вывода
  const [withdrawToken, setWithdrawToken] = useState('');
  const [withdrawDropdownOpen, setWithdrawDropdownOpen] = useState(false);
  const [withdrawSearchQuery, setWithdrawSearchQuery] = useState('');
  const [withdrawField2, setWithdrawField2] = useState(''); // сумма
  const [withdrawField3, setWithdrawField3] = useState(''); // сеть
  const [withdrawField4, setWithdrawField4] = useState('');

  // Стили для модальных окон
  const modalOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  };

  const modalContentStyle = {
    backgroundColor: '#2A2A33',
    width: '93%',
    padding: 10,
    paddingTop: 25,
    paddingBottom: 30,
    borderRadius: 20,
    minWidth: '300px',
    textAlign: 'center',
    position: 'relative',
  };

  const tg = window.Telegram.WebApp;
  const user_id = tg.initDataUnsafe.user.id;

  // Функция для получения баланса
  const fetchBalance = () => {
    fetch(`/balance/${user_id}`)
      .then((res) => res.json())
      .then((data) => {
        if (Object.keys(data.balances).length === 0) {
          setBalance({ balances: { 'USDT': 0 }, user_id: user_id });
        } else {
          setBalance(data);
        }
      })
      .catch((err) => console.error('Ошибка получения баланса:', err));
  };

  // Получение баланса при монтировании
  useEffect(() => {
    fetchBalance();
  }, [user_id]);

  // Запрос данных по курсам каждые 2 секунды
  useEffect(() => {
    const fetchData = () => {
      fetch('/rate')
        .then((res) => res.json())
        .then((data) => setTokens(data))
        .catch((err) => console.error('Ошибка получения курсов:', err.message));
    };

    fetchData();
    const interval = setInterval(fetchData, 2000);
    return () => clearInterval(interval);
  }, []);

  // Обработка отправки формы депозита
  const handleDepositSubmit = () => {
    fetch('/api/deposit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        type: 'deposit',
        user_id: user_id,
        token: depositToken,
        amount: depositField2,
        network: depositField3,
        address: depositField4,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log('Deposit response:', data);
        setDepositModalOpen(false);
        setConfirmationModalOpen(true);
        // Очистка полей
        setDepositToken('');
        setDepositSearchQuery('');
        setDepositField2('');
        setDepositField3('');
        setDepositField4('');
        // Обновляем баланс после депозита
        fetchBalance();
      })
      .catch((err) => console.error('Ошибка депозита:', err));
  };

  // Обработка отправки формы вывода
  const handleWithdrawSubmit = () => {
    fetch('/api/withdraw', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        type: 'withdraw',
        user_id: user_id,
        token: withdrawToken,
        amount: withdrawField2,
        network: withdrawField3,
        address: withdrawField4,
      }),
    })
      .then((res) => {
        if (!res.ok) {
          return res.json().then((errorData) => {
            throw errorData;
          });
        }
        return res.json();
      })
      .then((data) => {
        console.log('Withdraw response:', data);
        setWithdrawModalOpen(false);
        setConfirmationModalOpen(true);
        setWithdrawError(''); // сброс ошибки при успешном выводе
        // Очистка полей формы
        setWithdrawToken('');
        setWithdrawSearchQuery('');
        setWithdrawField2('');
        setWithdrawField3('');
        setWithdrawField4('');
        // Обновляем баланс после вывода
        fetchBalance();
      })
      .catch((err) => {
        console.error('Ошибка вывода:', err);
        setWithdrawError(err.error || 'Ошибка при выводе');
      });
  };

  return (
    <div>
      {/* Встроенные стили для анимаций */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .fade-in {
          animation: fadeIn 0.5s ease-in-out;
        }
        .action-btn {
          background-color: #60BDFF;
          color: white;
          padding: 10px 20px;
          border: none;
          border-radius: 30px;
          cursor: pointer;
          transition: background-color 0.3s ease, transform 0.3s ease;
        }
        .action-btn:hover {
          background-color: #4DAAE2;
          transform: scale(1.05);
        }
        .token-card {
          transition: transform 0.3s ease;
        }
        .token-card:hover {
          transform: scale(1.02);
        }
      `}</style>

      <TitleBlock type={'contact'} />

      {/* Основной блок профиля */}
      <div
        style={{
          backgroundColor: '#2A2A33',
          padding: 15,
          height: 500,
          marginTop: 30,
          marginBottom: 20,
          border: '1px solid #3E3E4B',
          borderRadius: 20,
          overflowY: 'auto'
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '20px',
            marginTop: '20px',
            marginBottom: '20px'
          }}
        >
          <button
            className="action-btn fade-in"
            style={{ height: 60, width: 150, fontSize: 18 }}
            onClick={() => setDepositModalOpen(true)}
          >
            <PiHandDepositBold style={{ fontSize: 26 }} /> Deposit
          </button>
          <button
            className="action-btn fade-in"
            style={{ height: 60, width: 150, fontSize: 18 }}
            onClick={() => setWithdrawModalOpen(true)}
          >
            <PiHandWithdrawBold style={{ fontSize: 26 }} /> Withdraw
          </button>
        </div>

        <div style={{marginTop: 15, marginBottom: 15, display: 'flex', justifyContent: 'center'}}>
          <h1 style={{color: 'white'}}>Your token</h1>
        </div>
        
        {(!balance || !tokens) ? (
          <p style={{ color: 'white', textAlign: 'center' }}>Загрузка...</p>
        ) : (
          balance.balances &&
          Object.keys(balance.balances).map((currency) => (
            <div
              key={currency}
              className="fade-in token-card"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                backgroundColor: '#1F1F25',
                border: '1px solid #3E3E4B',
                borderRadius: 30,
                height: 85,
                marginBottom: 10,
                paddingLeft: 20,
                paddingRight: 20
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <img
                  src={tokens[currency].icon}
                  alt={currency}
                  style={{ height: 32, marginRight: 10 }}
                />
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <strong style={{ color: 'white', margin: 0 }}>{currency}</strong>
                  <p style={{ color: 'white', margin: 0 }}>
                    {parseFloat(balance.balances[currency]).toFixed(6)}
                  </p>
                </div>
              </div>
              <p style={{ color: 'white', margin: 0 }}>
                {parseFloat(balance.balances[currency] * tokens[currency].price).toFixed(4)}$
              </p>
            </div>
          ))
        )}
      </div>

      {/* Модальное окно депозита */}
      {depositModalOpen && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <button
              onClick={() => setDepositModalOpen(false)}
              style={{
                position: 'absolute',
                top: 10,
                right: 10,
                background: 'transparent',
                border: 'none',
                color: 'white',
                fontSize: '24px',
                cursor: 'pointer',
              }}
            >
              ×
            </button>
            <h2 style={{ color: 'white', marginBottom: '20px' }}>Deposit</h2>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '25px' }}>
              <div style={{ position: 'relative', flex: '0 0 140px' }}>
                <div
                  onClick={() => setDepositDropdownOpen(!depositDropdownOpen)}
                  style={{
                    width: '100%',
                    border: '1px solid #3E3E4B',
                    borderRadius: 5,
                    padding: '0 10px',
                    height: 40,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                    color: 'white',
                  }}
                >
                  {depositToken ? tokens[depositToken].title : 'Select token'}
                </div>
                {depositDropdownOpen && (
                  <div
                    style={{
                      position: 'absolute',
                      top: 45,
                      left: 0,
                      right: 0,
                      backgroundColor: '#1F1F25',
                      border: '1px solid #3E3E4B',
                      borderRadius: 5,
                      zIndex: 10,
                      maxHeight: 350,
                      width: 350,
                      overflowY: 'auto'
                    }}
                  >
                    <div>
                      <input
                        type="text"
                        placeholder="Поиск токена"
                        value={depositSearchQuery}
                        onChange={(e) => setDepositSearchQuery(e.target.value)}
                        style={{
                          width: '100%',
                          backgroundColor: '#2D2D33',
                          border: 'none',
                          outline: 'none',
                          color: 'white',
                          padding: '5px 10px',
                          height: 40
                        }}
                      />
                    </div>
                    <div style={{ marginTop: 5 }}></div>
                    <div>
                      {Object.entries(tokens)
                        .filter(([key, info]) => {
                          if (!depositSearchQuery) return true;
                          const query = depositSearchQuery.toLowerCase();
                          return info.title.toLowerCase().includes(query) || key.toLowerCase().includes(query);
                        })
                        .map(([key, info]) => (
                          <div
                            key={key}
                            onClick={() => {
                              setDepositToken(key);
                              setDepositDropdownOpen(false);
                              setDepositSearchQuery('');
                            }}
                            style={{
                              padding: '8px 10px',
                              cursor: 'pointer',
                              color: 'white',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between'
                            }}
                          >
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <img src={info.icon} alt={info.title} style={{ height: 28, marginRight: 10 }} />
                              {info.title}
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </div>
              <input
                type="text"
                placeholder="Amount"
                value={depositField2}
                onChange={(e) => setDepositField2(e.target.value)}
                style={{
                  width: 100,
                  flex: 1,
                  height: 40,
                  backgroundColor: 'transparent',
                  border: '1px solid #3E3E4B',
                  borderRadius: 5,
                  padding: '0 10px',
                  color: 'white',
                  fontSize: 20
                }}
              />
            </div>

            <input
              type="text"
              placeholder="Write network"
              value={depositField3}
              onChange={(e) => setDepositField3(e.target.value)}
              style={{
                width: '100%',
                height: 40,
                backgroundColor: 'transparent',
                border: '1px solid #3E3E4B',
                borderRadius: 5,
                padding: '0 10px',
                color: 'white',
                fontSize: 20,
                marginBottom: '25px'
              }}
            />
            <input
              type="text"
              placeholder="Write address"
              value={depositField4}
              onChange={(e) => setDepositField4(e.target.value)}
              style={{
                width: '100%',
                height: 40,
                backgroundColor: 'transparent',
                border: '1px solid #3E3E4B',
                borderRadius: 5,
                padding: '0 10px',
                color: 'white',
                fontSize: 20,
                marginBottom: '25px'
              }}
            />

            <button
              onClick={handleDepositSubmit}
              className="btn"
              style={{
                color: 'white',
                border: '2px solid #60BDFF',
                width: '100%',
                height: 50,
                fontSize: 22,
                marginBottom: '10px',
                borderRadius: 5,
                backgroundColor: 'transparent'
              }}
            >
              Deposit
            </button>
          </div>
        </div>
      )}

      {/* Модальное окно вывода */}
      {withdrawModalOpen && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <button
              onClick={() => setWithdrawModalOpen(false)}
              style={{
                position: 'absolute',
                top: 10,
                right: 10,
                background: 'transparent',
                border: 'none',
                color: 'white',
                fontSize: '24px',
                cursor: 'pointer'
              }}
            >
              ×
            </button>
            <h2 style={{ color: 'white', marginBottom: '20px' }}>Withdraw</h2>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '25px' }}>
              <div style={{ position: 'relative', flex: '0 0 140px' }}>
                <div
                  onClick={() => setWithdrawDropdownOpen(!withdrawDropdownOpen)}
                  style={{
                    width: '100%',
                    border: '1px solid #3E3E4B',
                    borderRadius: 5,
                    padding: '0 10px',
                    height: 40,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                    color: 'white'
                  }}
                >
                  {withdrawToken ? tokens[withdrawToken].title : 'Select token'}
                </div>
                {withdrawDropdownOpen && (
                  <div
                    style={{
                      position: 'absolute',
                      top: 45,
                      left: 0,
                      right: 0,
                      backgroundColor: '#1F1F25',
                      border: '1px solid #3E3E4B',
                      borderRadius: 5,
                      zIndex: 10,
                      maxHeight: 350,
                      width: 350,
                      overflowY: 'auto'
                    }}
                  >
                    <div>
                      <input
                        type="text"
                        placeholder="Search token"
                        value={withdrawSearchQuery}
                        onChange={(e) => setWithdrawSearchQuery(e.target.value)}
                        style={{
                          width: '100%',
                          backgroundColor: '#2D2D33',
                          border: 'none',
                          outline: 'none',
                          color: 'white',
                          padding: '5px 10px',
                          height: 40
                        }}
                      />
                    </div>
                    <div style={{ marginTop: 5 }}></div>
                    <div>
                      {Object.entries(tokens)
                        .filter(([key, info]) => {
                          if (!balance || !balance.balances || balance.balances[key] === undefined) return false;
                          if (!withdrawSearchQuery) return true;
                          const query = withdrawSearchQuery.toLowerCase();
                          return info.title.toLowerCase().includes(query) || key.toLowerCase().includes(query);
                        })
                        .map(([key, info]) => (
                          <div
                            key={key}
                            onClick={() => {
                              setWithdrawToken(key);
                              setWithdrawDropdownOpen(false);
                              setWithdrawSearchQuery('');
                            }}
                            style={{
                              padding: '8px 10px',
                              cursor: 'pointer',
                              color: 'white',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between'
                            }}
                          >
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <img src={info.icon} alt={info.title} style={{ height: 28, marginRight: 10 }} />
                              {info.title}
                            </div>
                            {balance && balance.balances && balance.balances[key] !== undefined && (
                              <span style={{ fontSize: 12, color: '#60BDFF' }}>
                                {balance.balances[key]}
                              </span>
                            )}
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </div>
              <input
                type="text"
                placeholder="Amount"
                value={withdrawField2}
                onChange={(e) => setWithdrawField2(e.target.value)}
                style={{
                  flex: 1,
                  width: 100,
                  height: 40,
                  backgroundColor: 'transparent',
                  border: '1px solid #3E3E4B',
                  borderRadius: 5,
                  padding: '0 10px',
                  color: 'white',
                  fontSize: 20
                }}
              />
            </div>

            <input
              type="text"
              placeholder="Write network"
              value={withdrawField3}
              onChange={(e) => setWithdrawField3(e.target.value)}
              style={{
                width: '100%',
                height: 40,
                backgroundColor: 'transparent',
                border: '1px solid #3E3E4B',
                borderRadius: 5,
                padding: '0 10px',
                color: 'white',
                fontSize: 20,
                marginBottom: '25px'
              }}
            />

            <input
              type="text"
              placeholder="Write address"
              value={withdrawField4}
              onChange={(e) => setWithdrawField4(e.target.value)}
              style={{
                width: '100%',
                height: 40,
                backgroundColor: 'transparent',
                border: '1px solid #3E3E4B',
                borderRadius: 5,
                padding: '0 10px',
                color: 'white',
                fontSize: 20,
                marginBottom: '25px'
              }}
            />

            <button
              onClick={handleWithdrawSubmit}
              style={{
                marginRight: 10,
                color: 'white',
                border: '2px solid #60BDFF',
                width: '100%',
                height: 50,
                fontSize: 22,
                borderRadius: 5,
                backgroundColor: 'transparent'
              }}
            >
              Send
            </button>

            {withdrawError && (
              <p style={{ color: 'red', marginTop: '10px' }}>
                {withdrawError}. Ваш баланс: {balance?.balances[withdrawToken] || 0}, требуется: {withdrawField2}
              </p>
            )}
          </div>
        </div>
      )}
  
      {/* Модальное окно подтверждения */}
      {confirmationModalOpen && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <p style={{ color: 'white' }}>Форма отправлена. Ожидайте связи с ботом.</p>
            <button
              onClick={() => setConfirmationModalOpen(false)}
              style={{
                marginTop: 10,
                color: 'white',
                border: '2px solid #60BDFF',
                width: '100%',
                height: 50,
                fontSize: 22,
                borderRadius: 5,
                backgroundColor: 'transparent'
              }}
            >
              Закрыть
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProfileCard;
